module.exports = __webpack_public_path__ + "img/frame-white.9f7ffd6.webp";